module.exports = __webpack_public_path__ + "static/whitney-wolfe-herd-c5c0c903027c87795c07053017e8ff67.jpg";